/*
 * Copyright (c) 2020 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */

import {IComponentOptions, IScope, ITimeoutService} from 'angular';
import TSCockpitResultDTO from '../../../models/TSCockpitResultDTO';
import TSCockpitResult from '../../../models/TSCockpitResult';
import Chart = require('chart.js');
import ILogService = angular.ILogService;

declare let require: any;
declare let angular: any;
require('./dv-bar-charts.scss');

export class DvBarChartsComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        chartid: '<',
        dataset: '<'
    };
    template = require('./dv-bar-charts.html');
    controller = DvBarChartsController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvBarChartsController {

    static $inject = ['$log', '$window', '$timeout', '$scope'];

    chartid: string;
    dataset: TSCockpitResultDTO;

    public data: number[] = [];
    public label: string[] = [];
    public name: string;

    public myBarChart: any;

    constructor(private $log: ILogService, private $window: any, private $timeout: ITimeoutService, private $scope: IScope) {
    }

    $onInit() {

        this.$scope.$watch(() => {
            return this.dataset;
        }, (newValue, oldValue) => {
            this.update(newValue);
        });

        this.$timeout(() => {

            let ctx = document.getElementById(this.chartid);

            // @ts-ignore
            this.myBarChart = new Chart(ctx, {
                type: 'bar',
                data: {
                    datasets: [{
                        label: ' ',
                        data: [],
                        backgroundColor: ['#0074D9', '#FF4136', '#2ECC40', '#FF851B',
                            '#7FDBFF', '#B10DC9', '#FFDC00', '#001f3f', '#39CCCC',
                            '#01FF70', '#AAAAAA', '#F012BE', '#3D9970', '#111111',
                            '#FF6633', '#FFB399', '#F133FF', '#FFFF99', '#00B3E6',
                            '#E6B333', '#3366E6', '#999966', '#99FF99', '#B34D4D',
                            '#80B300', '#809900', '#E6B3B3', '#6680B3', '#66991A',
                            '#FF99E6', '#CCFF1A', '#FF1A66', '#E6331A', '#33FFCC',
                            '#66994D', '#B366CC', '#4D8000', '#B33300', '#CC80CC',
                            '#66664D', '#991AFF', '#E666FF', '#4DB3FF', '#1AB399',
                            '#E666B3', '#33991A', '#CC9999', '#B3B31A', '#00E680',
                            '#4D8066', '#809980', '#E6FF80', '#1AFF33', '#999933',
                            '#FF3380', '#CCCC00', '#66E64D', '#4D80CC', '#9900B3',
                            '#E64D66', '#4DB380', '#FF4D4D', '#99E6E6', '#6666FF']
                    }],
                    labels: []
                },
                options: {
                    responsive: true,
                    title: {
                        display: true,
                        text: this.name
                    },
                    legend: false,
                }
            });

            this.updateDataset(this.dataset.cockpitResult);
        });
    }

    private update(newValue: TSCockpitResultDTO) {
        console.debug('result has changed, update chart...');
        this.updateDataset(newValue.cockpitResult);
        this.name = newValue.name;
        this.myBarChart.options.title.text = newValue.name;
        this.myBarChart.update();
    }

    private updateDataset(cockpitResults: Array<TSCockpitResult>) {
        if (cockpitResults && this.myBarChart) {
            this.myBarChart.data.labels = [];
            this.myBarChart.data.datasets[0].data = [];

            for (const cockpitResult of cockpitResults) {
                this.myBarChart.data.labels.push(cockpitResult.label);
                this.myBarChart.data.datasets[0].data.push(cockpitResult.value)
            }
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-bar-charts/dv-bar-charts.ts